import $ from 'jquery';
import Registry from "./Registry";

export default class Context {
	constructor(contextData) {
		this.contextData = contextData;
		this.loadComponents();
		this.defaultContext();
	}

	async loadComponents(context) {
    let registry = new Registry();
    let selector = '[data-g-component]';

    // Ottieni gli elementi DOM nativi per iterare con un loop for...of che supporta await
    const elements = $(selector, context || document).get(); // Usa document come default se context non è fornito

    console.log(`Found ${elements.length} elements with [data-g-component]`);

    for (const elem of elements) {
      const $elem = $(elem); // Ottieni l'oggetto jQuery
      if (!$elem.data('g-component-initialized')) {
        const componentName = $elem.data('g-component');
        const componentInfo = registry.getComponent(componentName); // Ottiene la classe o la funzione importer

        if (componentInfo) {
          let Cmp = null; // Qui metteremo la classe costruttore finale
          try {
            // Verifica se componentInfo è la nostra funzione importer dinamica
            // Un modo semplice (ma non infallibile) è controllare se è una funzione e il nome è vuoto (funzione freccia)
            // O potremmo aggiungere una proprietà specifica se volessimo essere più robusti
            if (typeof componentInfo === 'function' && componentInfo.name === '') { // Controlla se è la funzione freccia () => import(...)
              console.log(`Componente "${componentName}": Trovato importer dinamico. Caricamento...`);
              // È la funzione importer: eseguila (restituisce la Promise di import()) e attendi
              const module = await componentInfo();
              // Assumiamo che i componenti usino 'export default'
              Cmp = module.default;
              if(Cmp) {
                console.log(`Componente "${componentName}": Caricato dinamicamente.`);
              } else {
                 console.warn(`Componente "${componentName}": L'import dinamico non ha restituito un export di default valido.`);
                 continue; // Salta al prossimo elemento
              }
            } else if (typeof componentInfo === 'function') {
              // È una funzione ma non la nostra importer, quindi è la classe stessa (caricata staticamente)
               console.log(`Componente "${componentName}": Trovata classe registrata staticamente.`);
              Cmp = componentInfo;
            } else {
                console.warn(`Componente "${componentName}": Informazione nel registry non valida (né classe né importer).`);
                continue; // Salta al prossimo elemento
            }

            // Ora che abbiamo la classe (Cmp), possiamo istanziarla
            if (typeof Cmp === 'function') {
              new Cmp(elem, this.contextData);
              $elem.data('g-component-initialized', true);
              console.log(`Componente "${componentName}": Istanziato con successo.`);
            } else {
               console.warn(`Componente "${componentName}": Il costruttore finale (Cmp) non è una funzione.`);
            }

          } catch (error) {
            console.error(`Errore durante il caricamento o l'inizializzazione del componente "${componentName}":`, error);
          }
        } else {
           console.warn(`Componente "${componentName}": Non trovato nel registry.`);
        }
      }
    }
     console.log("Scansione componenti completata.");
  }

	getCssVar(name, elem = document.documentElement) {
		return getComputedStyle(elem).getPropertyValue(name);
	}

	getBreakpoint(bp, elem = document.documentElement) {
		let value = this.getCssVar(`--breakpoint-${bp}`, elem);
		if (value) {
			value = parseInt(value);
		}
		return value || 0;
	}

	defaultContext() {
		$(() => {
			$('.rte table').wrap('<div class="responsive-table" />');
		});
	}
}
